export default "__VITE_ASSET__89b60ede__"